import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';

const Banner = ({content , img }) => {
    const carouselSectionRef = useRef(null);
    const headingRef = useRef(null);
    const animationTriggered = useRef(false);
    
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !animationTriggered.current) {
                        animationTriggered.current = true;
                        animateCarousel();
                        if (carouselSectionRef.current) {
                            observer.unobserve(carouselSectionRef.current);
                        }
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );
    
        const currentRef = carouselSectionRef.current; // Capture the ref value
    
        if (currentRef) {
            observer.observe(currentRef);
        }
    
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []); // Dependency array is still empty as intended
    
    const animateCarousel = () => {
        gsap.fromTo(headingRef.current, {
            yPercent: -20,
            opacity: 0,
        }, {
            yPercent: 0,
            opacity: 1,
            duration: 0.8,
            ease: "power2.out"
        });
    
        // Animate Swiper Slides
        if (carouselSectionRef.current) {
            const swiperSlides = carouselSectionRef.current.querySelectorAll(".swiper-slide");
            gsap.fromTo(
                swiperSlides,
                {
                    yPercent: 20,
                    opacity: 0,
                },
                {
                    yPercent: 0,
                    opacity: 1,
                    duration: 0.8,
                    ease: "power2.out",
                    stagger: 0.15,
                    delay: 0.3
                },
            );
        }
    };
    return(
        <div className="md:h-[calc(100vh-97px)] bg-gradient-to-b from-[#02C6F6] via-[#182186] to-[#181F85] w-full relative flex items-center [--swiper-pagination-color:#EA580C]
                [--swiper-pagination-bullet-inactive-color:#FFFFFF]
                [--swiper-pagination-bullet-size:10px]
                [--swiper-pagination-bullet-inactive-opacity:1]
                [--swiper-pagination-bullet-opacity:1]
                [&_.swiper-pagination-bullet-active]:!w-[10px]
                [&_.swiper-pagination-bullet-active]:!h-[10px]" ref={carouselSectionRef}>
            <img src={img} className='w-full h-full opacity-[0.2] absolute top-0 left-0' />
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                scrollbar={{ draggable: true }}
                pagination={{ clickable: true }}
                // navigation={true}
                breakpoints={{
                768: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 1,
                },
                }}
                autoplay={{delay: 4000,}}
                className="w-full md:h-[90%]"
                >
                    {content.map((item , index) => (
                        <SwiperSlide key={index} className='flex flex-col justify-center z-10 w-full h-full pt-[100px] md:pt-[150px] max-md:pb-[100px] px-5 min-[640px]:px-7 min-[700px]:px-[20px] min-[900px]:px-[5%] min-[1024px]:px-[20%]'>
                            {item?.heading && (<h2 className="text-[#FFFFFF] font-[600] text-lg sm:text-[20px] min-[900px]:text-[30px] leading-[70px]">{item.heading}</h2>)}
                            <h1 className="text-[#FFFFFF] font-[600] text-[43px] sm:text-[50px] min-[900px]:text-[65px] leading-[50px] sm:leading-[60px] min-[900px]:leading-[70px] mb-5">{item.subHeading}</h1>
                            <h3 className="text-[#FFFFFF] font-[700] text-[18px] sm:text-[20px] min-[900px]:text-[23px] leading-[24px] min-[900px]:leading-[26px] mb-[70px]">{item.description}</h3>
                            <div className="flex flex-wrap items-center gap-3">
                                <a href={item.url} target={item?.target === '_self' ? '_self' : '_blank'} className="bg-[#EA580C] rounded-full px-5 py-2 hover:bg-orange-500 text-[#FFFFFF] text-[14px] min-[900px]:text-[15px] font-[600] leading-[28px] self-star" url={item.url}>
                                    {item.linkText}
                                </a>
                                {item?.type === 'launchub' && (
                                    <a href='/ProgramDeck.pdf' download='Program Deck' target='_blank' className="bg-white rounded-full px-5 py-2 hover:bg-gray-200 text-black text-[14px] min-[900px]:text-[15px] font-[600] leading-[28px] self-star" url={item.url}>
                                        Download Program Deck
                                    </a>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    )
}
export default Banner;